import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import api from '../../utils/api';

interface Book {
  id: number;
  title: string;
  author: string;
  cover?: string;
  format: string;
  viewCount: number;
}

const Home: React.FC = () => {
  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);
  const [hotBooks, setHotBooks] = useState<Book[]>([]);
  const [randomBooks, setRandomBooks] = useState<Book[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBooks();
  }, []);

  const fetchBooks = async () => {
    try {
      setLoading(true);
      const { data } = await api.get('/books/home');
      setHotBooks(data.hotBooks || []);
      setRandomBooks(data.randomBooks || []);
    } catch (error) {
      console.error('获取首页数据失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const renderBookCard = (book: Book) => (
    <Link to={`/book/${book.id}`} key={book.id} className="book-card">
      {book.cover ? (
        <img src={book.cover} alt={book.title} className="book-cover" />
      ) : (
        <div 
          className="book-cover"
          style={{ 
            background: '#f0f0f0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#999'
          }}
        >
          暂无封面
        </div>
      )}
      <div className="book-info">
        <h3 className="book-title">{book.title || '未知书籍'}</h3>
        <p className="book-author">{book.author || '未知作者'}</p>
        <p style={{ fontSize: '12px', color: '#999', marginTop: '4px' }}>
          {book.viewCount} 次阅读
        </p>
      </div>
    </Link>
  );

  const renderBookSection = (title: string, books: Book[]) => (
    <section style={{ padding: '40px 0' }}>
      <h2 style={{ marginBottom: '24px' }}>{title}</h2>
      
      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <div className="spinner"></div>
          <p style={{ color: '#999', marginTop: '16px' }}>加载中...</p>
        </div>
      ) : books.length > 0 ? (
        <div className="book-grid">
          {books.map(book => renderBookCard(book))}
        </div>
      ) : (
        <div style={{ textAlign: 'center', padding: '60px 0' }}>
          <p style={{ color: '#999', fontSize: '16px' }}>暂无图书</p>
        </div>
      )}
    </section>
  );

  return (
    <div>
      <section style={{ padding: '60px 0', textAlign: 'center' }}>
        <h1 style={{ fontSize: '48px', marginBottom: '20px' }}>
          {isAuthenticated ? `欢迎回来，${user?.username || '书友'}！` : '发现阅读的乐趣'}
        </h1>
        <p style={{ fontSize: '18px', color: '#666', marginBottom: '30px' }}>
          {isAuthenticated 
            ? '继续您的阅读之旅，发现更多精彩图书' 
            : '加入 BookSocial，与千万书友分享阅读体验'}
        </p>
        <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
          <Link to="/books" className="btn btn-primary">
            探索书库
          </Link>
          {!isAuthenticated && (
            <Link to="/register" className="btn btn-default">
              立即加入
            </Link>
          )}
        </div>
      </section>

      {renderBookSection('热门图书', hotBooks)}
      {renderBookSection('盲盒图书', randomBooks)}
    </div>
  );
};

export default Home;
